export default "__VITE_ASSET__pTN2g_m___"